module.exports = __webpack_public_path__ + "static/media/home-bg.06095e77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-bg.jpg
// module id = 49
// module chunks = 0